import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  FaCloud,
  FaGraduationCap,
  FaHome,
  FaStar,
  FaTrophy,
  FaUniversity,
} from "react-icons/fa";

import CustomNavbar from "../components/CustomNavbar";
import Footer from "../components/Footer";
import { industries } from "../data/industries";

const CASE_STUDIES = [
  {
    title: "Banking Transformation Programme",
    Icon: FaUniversity,
    category: "Banking & Financial Services",
    description:
      "Led a complex transformation programme supporting regulatory compliance, operational improvement, and enhanced customer services.",
    result: "Improved Governance & Delivery Efficiency",
  },
  {
    title: "Salesforce Integration Programme",
    Icon: FaCloud,
    category: "Technology & Integration",
    description:
      "Integrated Salesforce with multiple enterprise platforms using MuleSoft and Boomi, creating a connected customer ecosystem.",
    result: "Streamlined Customer Journey",
  },
  {
    title: "Social Housing Digital Transformation",
    Icon: FaHome,
    category: "Housing Sector",
    description:
      "Implemented tenant self-service capabilities and digital solutions that improved engagement and service accessibility.",
    result: "Enhanced Tenant Experience",
  },
  {
    title: "Education Platform Development",
    Icon: FaGraduationCap,
    category: "Education",
    description:
      "Designed and developed a modern online learning platform supporting student engagement and digital education delivery.",
    result: "Improved Learning Accessibility",
  },
];

function CaseStudies() {
  return (
    <>
      <CustomNavbar />

      <style>{`
        .cs {
          --peach-deep: #ff6b35;
          --peach: #ff9066;
          --peach-soft: #f3c09f;
          --peach-tint: #ffe9e0;
          --peach-ink: #c2410c;
        }

        .cs-hero {
          position: relative; overflow: hidden;
          padding: clamp(52px, 7vw, 84px) 0;
          background:
            radial-gradient(42rem 24rem at 86% 6%, rgba(255,107,53,.30), transparent 62%),
            linear-gradient(135deg, #ff9066 0%, #f3c09f 48%, #fff8f5 100%);
          color: #0f172a;
        }
        .cs-hero__blob {
          position: absolute; border-radius: 50%; pointer-events: none;
          filter: blur(80px); opacity: .5;
          width: 24rem; height: 24rem; bottom: -9rem; left: -8rem;
          background: radial-gradient(circle, #fff3ec, transparent 70%);
        }
        .cs-badge {
          display: inline-flex; align-items: center; gap: 8px;
          background: #ffffffdd; color: var(--peach-ink);
          padding: 9px 22px; border-radius: 999px;
          font-weight: 700; font-size: .78rem; letter-spacing: .1em;
          box-shadow: 0 8px 20px rgba(194,65,12,.16);
        }
        .cs-hero__title {
          margin-top: 22px; font-weight: 800; letter-spacing: -.02em;
          font-size: clamp(1.9rem, 5vw, 3.2rem); line-height: 1.14;
        }
        .cs-hero__title em {
          font-style: normal;
          background: linear-gradient(96deg, #c2410c, #ff6b35 60%, #b91c1c);
          -webkit-background-clip: text; background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        .cs-hero__rule {
          width: 88px; height: 5px; border-radius: 999px; margin: 20px auto 0;
          background: linear-gradient(90deg, var(--peach-deep), #b91c1c);
        }
        .cs-hero__lead {
          max-width: 760px; margin: 20px auto 0; color: #4a3a33;
          font-size: clamp(1rem, 1.8vw, 1.12rem); line-height: 1.85;
        }

        /* Ends white so the navy band below reads as a clean break */
        .cs-list {
          padding: clamp(52px, 7vw, 88px) 0;
          background: linear-gradient(180deg, #fff8f5 0%, #ffffff 60%, #ffffff 100%);
        }
        .cs-card {
          position: relative; overflow: hidden; height: 100%;
          display: flex; flex-direction: column;
          padding: 30px 28px; border-radius: 22px;
          background: #fff; border: 1px solid #f0e4dd;
          box-shadow: 0 6px 22px rgba(194,65,12,.07);
          transition: transform .26s ease, box-shadow .26s ease, border-color .26s ease;
        }
        .cs-card::before {
          content: ""; position: absolute; top: 0; left: 0; right: 0; height: 4px;
          background: linear-gradient(90deg, var(--peach-deep), var(--peach-soft));
          transform: scaleX(0); transform-origin: left;
          transition: transform .34s cubic-bezier(.22,1,.36,1);
        }
        .cs-card__num {
          position: absolute; top: 18px; right: 24px;
          font-size: 2.6rem; font-weight: 800; line-height: 1;
          color: var(--peach); opacity: .14; transition: opacity .26s ease;
        }
        .cs-card__icon {
          width: 66px; height: 66px; border-radius: 18px; margin-bottom: 18px;
          display: grid; place-items: center;
          background: var(--peach-tint); color: var(--peach-deep);
          transition: background .26s ease, color .26s ease, transform .26s ease;
        }
        .cs-card__cat {
          display: inline-block; color: var(--peach-ink);
          font-weight: 700; font-size: .74rem; letter-spacing: .08em;
          text-transform: uppercase; margin-bottom: 8px;
        }
        .cs-card__title {
          color: #0f172a; font-weight: 700; font-size: 1.28rem;
          line-height: 1.3; margin-bottom: 12px;
        }
        .cs-card__text { color: #64748b; line-height: 1.8; font-size: .95rem; margin-bottom: 18px; }
        .cs-outcome {
          margin-top: auto;
          display: flex; align-items: flex-start; gap: 13px;
          background: linear-gradient(135deg, #fff3ee, #ffe9e0);
          border: 1px solid #ffd9c8; border-radius: 16px; padding: 16px 18px;
        }
        .cs-outcome__icon {
          width: 34px; height: 34px; border-radius: 11px; flex-shrink: 0;
          display: grid; place-items: center; font-size: .82rem; color: #fff;
          background: linear-gradient(135deg, var(--peach-deep), var(--peach));
        }
        .cs-outcome__l {
          display: block; color: var(--peach-ink); font-weight: 700;
          font-size: .7rem; letter-spacing: .1em; text-transform: uppercase;
        }
        .cs-outcome__v { display: block; color: #0f172a; font-weight: 700; margin-top: 3px; }

        /* A mouse hovers; a finger can't. On touch, lib/touchMotion.js adds
           .is-live as the card scrolls through the middle of the screen. */
        .cs-card:hover,
        .cs-card.is-live {
          transform: translateY(-8px);
          box-shadow: 0 24px 48px rgba(194,65,12,.18);
          border-color: var(--peach-soft);
        }
        .cs-card:hover::before,
        .cs-card.is-live::before { transform: scaleX(1); }
        .cs-card:hover .cs-card__num,
        .cs-card.is-live .cs-card__num { opacity: .28; }
        .cs-card:hover .cs-card__icon,
        .cs-card.is-live .cs-card__icon {
          background: linear-gradient(135deg, var(--peach-deep), var(--peach));
          color: #fff; transform: scale(1.06);
        }

        /* Sector band — not a second CTA; the footer carries one on every page */
        .cs-band {
          position: relative; overflow: hidden;
          padding: clamp(52px, 7vw, 84px) 0 clamp(92px, 10vw, 132px);
          color: #fff;
          background:
            radial-gradient(40rem 22rem at 84% 10%, rgba(255,107,53,.28), transparent 62%),
            linear-gradient(140deg, #131f36 0%, #0f172a 50%, #0b1120 100%);
        }
        .cs-band__mesh {
          position: absolute; inset: 0; pointer-events: none;
          background-image:
            linear-gradient(rgba(255,144,102,.07) 1px, transparent 1px),
            linear-gradient(90deg, rgba(255,144,102,.07) 1px, transparent 1px);
          background-size: 66px 66px;
          mask-image: radial-gradient(72% 60% at 50% 45%, #000 20%, transparent 100%);
          -webkit-mask-image: radial-gradient(72% 60% at 50% 45%, #000 20%, transparent 100%);
        }
        .cs-band__title {
          font-weight: 800; letter-spacing: -.02em; color: #fff;
          font-size: clamp(1.7rem, 3.8vw, 2.7rem); line-height: 1.16;
        }
        .cs-band__title em {
          font-style: normal;
          background: linear-gradient(105deg, var(--peach-soft), var(--peach) 55%, var(--peach-deep));
          -webkit-background-clip: text; background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        .cs-band__text { max-width: 700px; margin: 16px auto 0; color: #cbd5e1; line-height: 1.85; }
        .cs-chips { display: flex; flex-wrap: wrap; gap: 12px; justify-content: center; margin-top: 32px; }
        .cs-chip {
          display: inline-flex; align-items: center; gap: 10px;
          padding: 12px 20px; border-radius: 999px; text-decoration: none;
          background: rgba(255,255,255,.05);
          border: 1px solid rgba(255,144,102,.28);
          color: #e2e8f0; font-weight: 600; font-size: .92rem;
          transition: background .24s ease, color .24s ease,
                      border-color .24s ease, transform .24s ease;
        }
        .cs-chip svg { color: var(--peach); transition: color .24s ease; }
        .cs-chip:hover, .cs-chip:focus-visible {
          background: linear-gradient(135deg, var(--peach-deep), var(--peach));
          border-color: transparent; color: #0f172a; transform: translateY(-3px);
        }
        .cs-chip:hover svg { color: #fff; }

        @media (prefers-reduced-motion: reduce) {
          .cs-card, .cs-card::before, .cs-card__icon, .cs-chip { transition: none; }
          .cs-card:hover, .cs-chip:hover { transform: none; }
        }
      `}</style>

      <div className="cs">
        {/* Hero */}
        <section className="cs-hero">
          <span className="cs-hero__blob" />
          <Container className="text-center" style={{ position: "relative", zIndex: 1 }}>
            <span className="cs-badge" data-aos="fade-up">
              <FaStar />
              CASE STUDIES
            </span>

            <h1 className="cs-hero__title" data-aos="fade-up" data-aos-delay="60">
              Success Stories That <em>Deliver Results</em>
            </h1>

            <div className="cs-hero__rule" />

            <p className="cs-hero__lead" data-aos="fade-up" data-aos-delay="120">
              Discover how Sarvavya has helped organizations achieve
              transformation, improve customer experiences, modernize technology
              platforms, and deliver measurable business outcomes across multiple
              industries.
            </p>
          </Container>
        </section>

        {/* Studies */}
        <section className="cs-list">
          <Container>
            <Row className="g-4">
              {CASE_STUDIES.map((study, i) => {
                const { Icon } = study;
                return (
                  <Col lg={6} key={study.title} data-aos="fade-up" data-aos-delay={(i % 2) * 90}>
                    <div className="cs-card" data-live>
                      <span className="cs-card__num">
                        {String(i + 1).padStart(2, "0")}
                      </span>

                      <span className="cs-card__icon">
                        <Icon size={28} />
                      </span>

                      <span className="cs-card__cat">{study.category}</span>
                      <h2 className="cs-card__title">{study.title}</h2>
                      <p className="cs-card__text">{study.description}</p>

                      <div className="cs-outcome">
                        <span className="cs-outcome__icon">
                          <FaTrophy />
                        </span>
                        <span>
                          <span className="cs-outcome__l">Key Outcome</span>
                          <span className="cs-outcome__v">{study.result}</span>
                        </span>
                      </div>
                    </div>
                  </Col>
                );
              })}
            </Row>
          </Container>
        </section>

        {/* Sectors */}
        <section className="cs-band">
          <span className="cs-band__mesh" />
          <Container className="text-center" style={{ position: "relative", zIndex: 1 }}>
            <h2 className="cs-band__title" data-aos="fade-up">
              Outcomes Across <em>Every Sector We Serve</em>
            </h2>
            <p className="cs-band__text" data-aos="fade-up" data-aos-delay="80">
              The work above spans regulated, high-stakes industries — each with
              its own constraints, customers, and definition of success.
            </p>

            <div className="cs-chips" data-aos="fade-up" data-aos-delay="150">
              {industries.map(({ slug, title, Icon }) => (
                <Link to={`/industries/${slug}`} className="cs-chip" key={slug}>
                  <Icon />
                  {title}
                </Link>
              ))}
            </div>
          </Container>
        </section>
      </div>

      <Footer />
    </>
  );
}

export default CaseStudies;
